<template lang="pug">
.container.grid-lg.py-2
  .no-print
    form.columns.align-center.my-2(@submit.prevent="listar")
      .pb-1.column.col-auto
        small Cadastro
        int.form-input.input-sm(placeholder="Cadastro", v-model="q.id_eq")
      .pb-1.column.col-auto
        small Vencimento inicial
        datepicker(
          v-model="q.alvara_vence_em_gteq",
          placeholder="inicial",
          input-class="form-input input-sm"
        )
      .pb-1.column.col-auto
        small Vencimento final
        datepicker(
          v-model="q.alvara_vence_em_lteq",
          placeholder="final",
          input-class="form-input input-sm"
        )
      .pb-1.column.col-auto
        small {{ "contribuinte.cpf_cnpj" | tModel }}
        input-cpf-cnpj.form-input.input-sm(
          v-model="q['contribuinte.cpf_cnpj_eq']"
        )
      .pb-1.column.col-auto
        small {{ "cadastro_imobiliario.patrimonio" | tModel }}
        int.form-input.input-sm(
          placeholder="Código do patrimonio",
          v-model="q['imobiliario.patrimonio_eq']"
        )
      .pb-1.column.col-auto
        small {{ "cadastro_imobiliario.situacao_lote" | tModel }}
        int.form-input.input-sm(
          :placeholder="'cadastro_imobiliario.situacao_lote' | tModel",
          v-model="q['imobiliario.situacao_lote_eq']"
        )
      .pb-1.column.col-auto
        br
        button.btn.btn-sm.btn-link.tooltip.tooltip-left(data-tooltip="Filtrar")
          i.fa.fa-search.fa-lg

  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      table.table.table-striped.table-sm
        thead
          tr
            th {{ "cadastro.numero" | tModel }}
            th {{ "cadastro_economico.alvara_numero" | tModel }}
            th {{ "cadastro_economico.alvara_expedido_em" | tModel }}
            th {{ "cadastro_economico.alvara_vence_em" | tModel }}
            th {{ "cadastro_economico.aberto_em" | tModel }}
            th {{ "cadastro.situacao" | tModel }}
            th {{ "contribuinte.cpf_cnpj" | tModel }}
            th {{ "contribuinte.razao_social" | tModel }}
            th {{ "cadastro_economico.cadastro_imobiliario_numero" | tModel }}
            th.actions-col
        tbody
          tr(v-for="eco in list")
            td {{ eco.id }}
            td {{ eco.alvara_numero }}
            td {{ eco.alvara_expedido_em | date("DD/MM/YYYY") }}
            td {{ eco.alvara_vence_em | date("DD/MM/YYYY") }}
            td {{ eco.aberto_em | date("DD/MM/YYYY") }}
            td {{ eco.cadastro.situacao.descricao }}
            td {{ eco.cadastro.contribuinte.cpf_cnpj | cpfCnpj }}
            td {{ eco.cadastro.contribuinte.razao_social }}
            td {{ eco.imobiliario_id }}
            td.no-print
              router-link(
                :to="{ name: 'app.osm.consultas.cadastros.show', params: { id: eco.cadastro.id } }"
              )
                btn-icon(name="show")
      .my-2.text-right(v-if="pages > 1")
        btn-paginate(
          :page="page",
          :pages="pages",
          :count="count",
          @go-page="goPage",
          @prev-page="prevPage",
          @next-page="nextPage"
        )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"

export default {
  vuex: {
    "consulta/cadastroAlvarasVencer": vuexDefaultMapping,
  },

  data() {
    return {
      q: {},
    }
  },

  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.q.alvara_vence_em_gteq) {
      this.q.alvara_vence_em_gteq = new Date()
    }
    if (!this.q.alvara_vence_em_lteq) {
      const venceEm = new Date()
      venceEm.setMonth(venceEm.getMonth() + 1)
      this.q.alvara_vence_em_lteq = venceEm
    }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
